import { axiosApiInstance } from './axios';

// -------------------------------------------------------------

const apiRoot = '';

const cigarRecipesApi = {
  // CREATE
  create: async (data) => {
    try {
      const res = await axiosApiInstance.post(`${apiRoot}/cigarRecipes`, data);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  // GET
  get: async () => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/cigarRecipes`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  getById: async (id) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/cigarRecipes/${id}`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  getByIdWithTobaccos: async (id) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/cigarRecipes/v2/with-tobaccos/${id}`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  getByIdForTooltip: async (id) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/cigarRecipes/v2/for-tooltip/${id}`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  getCigarRecipesHistory: async (id) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/cigarRecipes/cigarRecipesHistory/${id}`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  // PUT
  update: async (data, id) => {
    try {
      const res = await axiosApiInstance.put(`${apiRoot}/cigarRecipes/${id}`, data);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },
};

export default cigarRecipesApi;
